var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-profit" }, [
    _c("div", { staticClass: "profit-wrap clearfix" }, [
      _c("div", { staticClass: "profit-team profit-cube fl-l" }, [
        _c("div", { staticClass: "profit-title" }, [
          _vm._v(_vm._s(_vm.team.title))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "profit-text" },
          _vm._l(_vm.team.content, function(ct) {
            return _c("p", { key: ct.text }, [
              _c("img", { attrs: { src: ct.icon, alt: "" } }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(ct.text))])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "profit-button" }, [
          _c("a", { attrs: { href: "/s/team" } }, [
            _vm._v(_vm._s(_vm.team.btn))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "profit-school profit-cube fl-l" }, [
        _c("div", { staticClass: "profit-title" }, [
          _vm._v(_vm._s(_vm.ents.title))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "profit-text" },
          _vm._l(_vm.ents.content, function(ct) {
            return _c("p", { key: ct.text }, [
              _c("img", { attrs: { src: ct.icon, alt: "" } }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(ct.text))])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "profit-button" }, [
          _c("a", { attrs: { href: "/s/enterprise" } }, [
            _vm._v(_vm._s(_vm.ents.btn))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }